export default __webpack_public_path__ + "static/media/Image.1cae8392.svg";